//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "uploadModal",
  data: function data() {
    return {
      proName: "点击选择上传文件",
      isActive: false
    };
  },
  props: {
    fileData: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {},
  methods: {
    newData: function newData() {
      this.proName = "点击选择上传文件", this.isActive = false;
    },
    Upload2: function Upload2() {
      $(".file")[0].value = "";
      $(".file")[0].type = "text";
      setTimeout(function () {
        $(".file")[0].type = "file";
      }, 200);
    },
    Upload: function Upload(e) {
      var files = this.$refs.selector.files;

      if (files.length > 0) {
        this.proName = "点击选择上传文件", this.isActive = false;
      }

      this.$emit("fileUpload", files);
    },
    getData: function getData(name, v) {
      this.proName = name;
      this.isActive = v;
    }
  }
};